<template>
  <v-card class="mx-1">
    <v-breadcrumbs
      v-if="!homePage()"
      class="mt-8 mb-6 px-4 py-2"
      :items="breadcrumbsGen">
      <template v-slot:divider >
        <v-icon size="22">mdi-chevron-right</v-icon>
      </template>
      <template
        v-slot:item="{ item }">
        <v-breadcrumbs-item  :to="item.to" link class="text-capitalize">
          {{ item.text }}
        </v-breadcrumbs-item>
      </template>
    </v-breadcrumbs>
  </v-card>
</template>

<script>
export default {
  computed: {
    breadcrumbsGen() {
      let pathArray = this.$route.path.split("/");
      pathArray.shift();
      let breadcrumbs = pathArray.reduce((breadcrumbArray, patch) => {
        if(patch=='bankaccount') patch = 'Bank Account';
        if(patch=='batchdeposit') patch = 'Batch Deposit';
        if(patch=='batchpayment') patch = 'Batch Payment';
        if(patch=='billmaterial') patch = 'Bill of Material';
        if(patch=='byaccount') patch = 'By Account';
        if(patch=='bychannel') patch = 'By Channel';
        if(patch=='bycustomer') patch = 'By Customer';
        if(patch=='bylocation') patch = 'By Location';
        if(patch=='byitem') patch = 'By Item';
        if(patch=='bysalevisits') patch = 'By Sales Visits';
        if(patch=='bytownship') patch = 'By Township';
        if(patch=='byrep') patch = 'By Sales Rep';
        if(patch=='byuser') patch = 'By User';
        if(patch=='byvehicle') patch = 'By Vehicle';
        if(patch=='creativeproject') patch = 'Creative Project';
        if(patch=='chatxc') patch = 'ChatXC';
        if(patch=='companypolicy') patch = 'Company Policy';
        if(patch=='currencyrate') patch = 'Currency Rate';
        if(patch=='customerreport') patch = 'Customer Report';
        if(patch=='employeeface') patch = 'Employee Face';
        if(patch=='expensebill') patch = 'Expense Bill';
        if(patch=='expensereport') patch = 'Expense Report';
        if(patch=='financereport') patch = 'Finance Report';
        if(patch=='fixedasset') patch = 'Fixed Asset';
        if(patch=='fabill') patch = 'Asset Bill';
        if(patch=='gl-journal') patch = 'General Journal';
        if(patch=='gl-ledger') patch = 'General Ledger';
        if(patch=='gl-map') patch = 'GL Mapping';
        if(patch=='gl-post') patch = 'GL Post';
        if(patch=='gl-report') patch = 'GL Report';
        if(patch=='is') patch = 'Income Statement';
        if(patch=='bs') patch = 'Balance Sheet';
        if(patch=='gl') patch = 'General Ledger';
        if(patch=='tb') patch = 'Trial Balance';
        if(patch=='inventorycount') patch = 'Inventory Count';
        if(patch=='inventoryjournal') patch = 'Inventory Journal';
        if(patch=='itemcategory') patch = 'Item Category';
        if(patch=='itemgroup') patch = 'Item Group';
        if(patch=='itemsubcategory') patch = 'Item Subcategory';
        if(patch=='jobposting') patch = 'Job Posting';
        if(patch=='loadingorder') patch = 'Loading Order';
        if(patch=='locationtracking') patch = 'Location Tracking';
        if(patch=='marketcampaign') patch = 'Marketing Campaign';
        if(patch=='marketcontent') patch = 'Marketing Content';
        if(patch=='marketplatform') patch = 'Marketing Platform';
        if(patch=='marketproject') patch = 'Marketing Project';
        if(patch=='payrollentry') patch = 'Payroll Entry';
        if(patch=='payrollrecurring') patch = 'Payroll Recurring';
        if(patch=='paymethod') patch = 'Pay Method';
        if(patch=='paystatement') patch = 'Pay Statement';
        if(patch=='pricelist') patch = 'Price List';
        if(patch=='purchaseorder') patch = 'Purchase Order';
        if(patch=='purchasereceipt') patch = 'Purchase Receipt';
        if(patch=='routeplan') patch = 'Route Plan';
        if(patch=='saleschannel') patch = 'Sales Channel';
        if(patch=='salescost') patch = 'Sales Cost';
        if(patch=='salesorder') patch = 'Sales Order';
        if(patch=='salesrep') patch = 'Sales Rep';
        if(patch=='salesreport') patch = 'Sales Report';
        if(patch=='salessummary') patch = 'Sales Summary';
        if(patch=='salestarget') patch = 'Sales Target';
        if(patch=='shiftschedule') patch = 'Shift Schedule';
        if(patch=='systemsetting') patch = 'System Settings';
        if(patch=='timereport') patch = 'Time Report';
        if(patch=='timetracking') patch = 'Time Tracking';
        if(patch=='webproject') patch = 'Web Project';

        breadcrumbArray.push({
          text: patch,
          to: null
        })
        return breadcrumbArray;
      }, [])
      breadcrumbs.unshift({text: 'TradeXC', to: '/dashboard'});
      return breadcrumbs;
    }
  },
  methods: {
    homePage() {
      return this.$route.path === "/" || this.$route.path === "/dashboard";
    },
  },
}
</script>

<style src="./Breadcrumbs.scss" lang="scss"></style>

